import { SettingsManager } from "@viamap/viamap2-common"
import { EjendomDataFormated, EjendomEjerskab, EjendomHandel, ViamapEjendomStatsData } from "./DLLTypes";

export class dllCollector {

   static async EjendomData(BFENummer: string): Promise<EjendomDataFormated> {
      const body = {
         "sagsNr": "ASM_1",
         "BFEnr": BFENummer,
         "matrikler": []
      }
      return fetchDLL("ejendomdataformated", body);
   }

   static async EjendomHandel(BFENummer: string): Promise<EjendomHandel> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchDLL("getHandelsOplysning", body);
   }

   static async EjendomEjerskab(BFENummer: string): Promise<EjendomEjerskab> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchDLL("getejerskab", body);
   }

   static async OmrådeStatistikEjendomme(kommuneNr: string, postNr: string): Promise<ViamapEjendomStatsData> {
      const body = {
         "kommuneNr": kommuneNr,
         "postNr": postNr,
         "kategori": "1"
      };
      return fetchDLL("getEjendomStats", body);
   }


}

function fetchDLL(endpoint: string, body: any): Promise<any> {
   const baseUrl = SettingsManager.getSystemSetting("dllServicesUrl");
   const url = "https://" + baseUrl + "/" + endpoint;
   const API_KEY = SettingsManager.getSystemSetting("dllServicesKey");

   return fetch(url, {
      method: "POST",
      headers: {
         "x-api-key": API_KEY ? API_KEY : "",
         "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
   }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      return response.json();
   });
}



